import { EventEmitter } from 'events';
import {action, observable} from 'mobx';

export class ConfirmStore {

  rootStore = null;

  @observable isShown = false;
  contentText = '';
  currentPromise = null;
  promiseResolver = new EventEmitter();

  constructor(initialStateObj, rootStore) {
    this.rootStore = rootStore;
  }

  @action.bound
  openConfirm({ contentText }) {
    this.isShown = true;
    this.contentText = contentText;
    
    this.promiseResolver.removeAllListeners('resolve'); 
    this.promiseResolver.removeAllListeners('reject');
    
    return new Promise((resolve, reject) => {
      let handleResolve, handleReject;
      
      handleResolve = () => {
        this.promiseResolver.removeListener('reject', handleReject);
        resolve();
      };

      handleReject = () => {
        this.promiseResolver.removeListener('resolve', handleResolve);
        reject();
      };

      this.promiseResolver.once('resolve', handleResolve);
      this.promiseResolver.once('reject', handleReject);
    });
  }

  @action.bound
  closeConfirm() {
    this.isShown = false;
  }

  handleCancel = () => {
    this.closeConfirm();
    this.promiseResolver.emit('reject');
  };

  handleAccept = () => {
    this.closeConfirm();
    this.promiseResolver.emit('resolve');
  }
}